/** Маршруты юридических документов витрины. */
export const legalPages = {
  personalDataConsent: '/agreement',
  privacyPolicy: '/privacy',
  userAgreement: '/offer',
  publicOffer: '/offer',
  returnsPolicy: '/returns',
  dataTransferConsent: '/data-transfer',
} as const
